import {useEffect} from 'react';

export const useSeo = (title, description, meta = {}) => {
    useEffect(() => {
        document.title = title;

        // Update meta description
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', description);
        } else {
            const newMeta = document.createElement('meta');
            newMeta.name = 'description';
            newMeta.content = description;
            document.head.appendChild(newMeta);
        }

        // Update other meta tags
        Object.entries(meta).forEach(([name, content]) => {
            const metaTag = document.querySelector(`meta[name="${name}"]`);
            if (metaTag) {
                metaTag.setAttribute('content', content);
            }
        });
    }, [title, description, meta]);
};